// extracted by mini-css-extract-plugin
export default {"offcanvas":"employee_offcanvas__Bt0B7","tbl_h_xl":"employee_tbl_h_xl__7oi9H"};